export default __webpack_public_path__ + "static/media/swagger-logo.0becc1f7.png";